import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-merge-carts-checkout-dialog',
  templateUrl: './merge-carts-checkout-dialog.html',
  styleUrls: ['./merge-carts-checkout-dialog.scss'],
})
export class MergeCartsCheckoutDialogComponent implements OnInit {

  mergeComponentData: any

  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.data$.subscribe((data) => {
      console.log('MergeCartsCheckoutDialogComponent data: ', data);
      this.mergeComponentData = data;
    })
  }

  ngOnInit(): void {}

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.MERGE_CHEKOUT_CART_ITEMS,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
